import { render, staticRenderFns } from "./return3.vue?vue&type=template&id=3631f332&scoped=true"
import script from "./return3.vue?vue&type=script&lang=js"
export * from "./return3.vue?vue&type=script&lang=js"
import style0 from "./return3.vue?vue&type=style&index=0&id=3631f332&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631f332",
  null
  
)

export default component.exports